"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @summary This function is optional.
 * Most of this information can be derived on the server.
 * Leaving this in just in case someone wants to use it partially,
 * for example filling in latitude and longitude could be useful.
 */
function createContext(_a) {
    var tenant = _a.tenant, referrer = _a.referrer, domain = _a.domain, userAgent = _a.userAgent;
    return {
        tenant: tenant,
        referrer: referrer,
        domain: domain,
        userAgent: userAgent,
    };
}
exports.default = createContext;
//# sourceMappingURL=createContext.js.map